/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import type { Provider } from "@ethersproject/providers";
import type {
  IGnosisWrapper,
  IGnosisWrapperInterface,
} from "../../contracts/IGnosisWrapper";

const _abi = [
  {
    inputs: [],
    name: "gnosisSafe",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_accessControl",
        type: "address",
      },
      {
        internalType: "address",
        name: "_gnosisSafe",
        type: "address",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

export class IGnosisWrapper__factory {
  static readonly abi = _abi;
  static createInterface(): IGnosisWrapperInterface {
    return new utils.Interface(_abi) as IGnosisWrapperInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): IGnosisWrapper {
    return new Contract(address, _abi, signerOrProvider) as IGnosisWrapper;
  }
}
